export default "__VITE_ASSET__CrOeG2R9__"